import moment from 'moment';

export default class Message {
  constructor({
    id,
    from,
    to,
    message,
    type,
    time,
    status,
    protocol,
    agent_id,
    agent_name,
    avatar,
    system_message,
    mimetype,
    caption,
    answeredMessage,
    message_id,
    message_media_type,
    idPrimary,
    idSecondary,
    bot,
    customFields,
    header_agent_name,
    header_show_agent_name,
    header_show_complete_agent_name,
    replyMessageId,
    apiMessageId,
    forwarded,
    messageAnswered,
    strategyCampaign,
    event,
  }) {
    this.idPrimary =
      idPrimary ||
      Date.now() + (((1 + Math.random()) * 0x10000000) | 0).toString(16);
    this.idSecondary =
      idSecondary ||
      Date.now() + (((1 + Math.random()) * 0x10000000) | 0).toString(16);
    this.id =
      id || Date.now() + (((1 + Math.random()) * 0x10000000) | 0).toString(16);
    this.from = from;
    this.to = to;
    this.message = message;
    this.type = type;
    this.time = time || moment().format('YYYY-MM-DD HH:mm:ss');
    this.status = status || null;
    this.protocol = protocol;
    this.agent_id = agent_id;
    this.agent_name = agent_name;
    this.avatar = avatar;
    this.system_message = system_message;
    this.mimetype = mimetype;
    this.caption = caption;
    this.isAnswered = answeredMessage;
    this.message_id = message_id;
    this.message_media_type = message_media_type;
    this.bot = bot;
    this.customFields = customFields;
    this.header_agent_name = header_agent_name;
    this.header_show_agent_name = header_show_agent_name;
    this.header_show_complete_agent_name = header_show_complete_agent_name;
    if (replyMessageId) this.replyMessageId = replyMessageId;
    this.apiMessageId = apiMessageId;
    this.forwarded = forwarded;
    this.messageAnswered = messageAnswered || {};
    this.strategyCampaign = strategyCampaign || {};
    this.event = event;
  }

  _setAvatar(avatar = null) {
    if (!avatar) return;

    const url =
      process.env.NODE_ENV == 'development'
        ? process.env.API_URL
        : window.CONFIG.weactionapi.url;

    this.avatar = url.slice(0, -1) + avatar;
  }
}
